(()=>{const init=()=>{const button=document.querySelector('.j-menu-toggle');const menu=document.getElementById('j-mobile-nav');if(!button||button.dataset.bound)return;button.dataset.bound='true';const close=()=>{button.setAttribute('aria-expanded','false');button.setAttribute('aria-label','Open menu');menu.hidden=true};button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!open));button.setAttribute('aria-label',open?'Open menu':'Close menu');menu.hidden=open});document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!menu.hidden){close();button.focus()}});document.addEventListener('click',e=>{if(!menu.hidden&&!e.target.closest('.j-header'))close()});};document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();document.addEventListener('shopify:section:load',init)})();

// Keep the front view until the alternate image has decoded successfully.
(() => {
  const prepare = async (card) => {
    const alternate = card.querySelector('.j-card-alternate');
    if (!alternate || card.dataset.alternateBound) return;
    card.dataset.alternateBound = 'true';
    alternate.loading = 'eager';
    try {
      await alternate.decode();
      if (alternate.naturalWidth) card.classList.add('j-alternate-ready');
    } catch (_) { /* A failed alternate must never hide the front image. */ }
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { observer.unobserve(entry.target); prepare(entry.target); }
    });
  }, { rootMargin: '200px' }) : null;
  const initCards = () => document.querySelectorAll('.j-card-image').forEach(card => {
    if (!card.querySelector('.j-card-alternate')) return;
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
      observer ? observer.observe(card) : prepare(card);
    }
    card.addEventListener('focus', () => prepare(card), { once: true });
  });
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initCards) : initCards();
  document.addEventListener('shopify:section:load', initCards);
})();
